<div class="header">
  <span class="header-title">{{ title | titlecase }}</span>
  <div class="buttons-container" *ngIf="buttons" [style.justify-content]="justyButtons">
    <abc-button
      *ngFor="let button of buttons"
      class="button"
      [class]="button.statfullButton ? (button.active ? 'button-active-status' : 'button-desactive-status') : ''"
      [icon]="button.icon"
      [disabled]="button.disabled ?? false"
      [toolTipContent]="button.toolTipContent"
      (click)="handlebuttonClick(button)"
    ></abc-button>
  </div>
  <div *ngIf="!hideFilterPanel" class="searchBar-container">
    <abc-drop-down-button
      *ngIf="!disableFilterMode"
      [height]="'36px'"
      class="search-type-dropdown-button"
      [icon]="currentFilterOption?.icon"
      displayExpr="caption"
      [dropDownOptions]="{ width: 180 }"
      [items]="filterOptions"
      keyExpr="searchMode"
      (onItemClick)="filterOptionChanged($event)"
    ></abc-drop-down-button>
    <abc-text-box
      [height]="'36px'"
      [width]="'90%'"
      (onValueChanged)="searchTermChanged($event)"
      [valueChangeEvent]="'keyup'"
      [placeholder]="res.get('searchBar-placeholder')"
      #searchInput
    >
    </abc-text-box>
  </div>
</div>
